<accordion-configurations-tree *ngIf="showAccordionTabs"
                               [selectedConfId]="selectedTreeNodeId"
                               (nodeSelected)="onConfigurationNodeSelect($event)">
</accordion-configurations-tree> 

<accordion-tabs *ngIf="!showOverlay" [tabs]="tabs"
                [selectedTabId]="selectedTabId"
                [configurationId]="configurationId"
                [containerId]="containerId">
</accordion-tabs>

<!-- Accordion sub configuration tabs -->
<accordion-overlay *ngIf="showOverlay" [title]="subConfTitle">
  <ng-container *ngIf="subConfigurationTabs.length > 0">
    <accordion-tabs [tabs]="subConfigurationTabs"
                    [containerId]="containerId"
                    [configurationId]="activeSubConfigurationId"
                    [selectedTabId]="selectedSubTabId">
    </accordion-tabs>
  </ng-container>
</accordion-overlay>
